

import React, { useEffect, useState } from "react";
import axios from "axios"; // Ensure axios is installed
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
import  * as Constants from '../Constants/Constants'
import Swal from 'sweetalert2';




import { Form, Button, Alert, Container, Row, Col } from 'react-bootstrap';

const Alumni = () => {
  const [alumni, setAlumni] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(10);

  ///Register
  const [fullName, setFullName] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [emailAddress, setEmailAddress] = useState('');
  const   
 [stayInHostelFrom, setStayInHostelFrom] = useState('');
  const [stayInHostelTo, setStayInHostelTo] = useState('');
  const [qualification, setQualification] = useState('');
  const [communicationAddress, setCommunicationAddress] = useState('');
  const [permanentAddress, setPermanentAddress] = useState('');   

  const [workplace, setWorkplace] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    // Handle form submission here
    console.log({
      fullName,
      mobileNumber,
      emailAddress,
      stayInHostelFrom,
      stayInHostelTo,
      qualification,
      communicationAddress,
      permanentAddress,
      workplace,
    });

    const formData = {
      userName: fullName,
      email: emailAddress,
      mobile: mobileNumber,
      com_adds: communicationAddress,
      perm_adds: permanentAddress,
      working: workplace,
      year_join: stayInHostelFrom,
      year_end: stayInHostelTo,
      qualification: qualification,
    };
  
    try {
      const response = await axios.post(`${Constants.BASE_URL}?apitype=202`, formData);
      
      // Check if the submission was successful
      if (response.data.status === "success") {
        Swal.fire('Success!', 'Registration successful!', 'success');
  
        // Reset form fields after successful submission
        setFullName('');
        setMobileNumber('');
        setEmailAddress('');
        setStayInHostelFrom('');
        setStayInHostelTo('');
        setQualification('');
        setCommunicationAddress('');
        setPermanentAddress('');
        setWorkplace('');
      } else {
        Swal.fire('Error!', 'Registration failed. Please try again.', 'error');
      }
    } catch (error) {
      Swal.fire('Error!', 'An error occurred while submitting the form.', 'error');
    }


  };

  const years = Array.from({ length: 35 }, (_, i) => 1990 + i);

  // Fetch data from the API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${Constants.BASE_URL}?apitype=102`); // Replace with your API endpoint
        if (response.data.status) {
          setAlumni(response.data.mMembersData);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // Pagination Logic
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = alumni.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(alumni.length / recordsPerPage);

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="container mt-5">
      <h1 className="text-center mb-4">LIST OF ALUMNI OF KSV NILAYA</h1>
      <div className="table-responsive"> {/* Makes the table responsive */}
        <table className="table table-bordered table-striped">
          <thead>
            <tr>
              <th style={{ backgroundColor: '#124270', color: 'white' }}>SL No</th>
              <th style={{ backgroundColor: '#124270', color: 'white' }}>Name</th>
              <th style={{ backgroundColor: '#124270', color: 'white' }}>Place</th>
            </tr>
          </thead>
          <tbody>
            {currentRecords.length > 0 ? (
              currentRecords.map((member) => (
                <tr key={member.sl_no}>
                  <td>{member.sl_no}</td>
                  <td>{member.name}</td>
                  <td>{member.perm_adds}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center">No records found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <nav>
        <ul className="pagination justify-content-center">
          {Array.from({ length: totalPages }, (_, index) => (
            <li
              key={index + 1}
              className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
              onClick={() => handlePageChange(index + 1)}
            >
              <a className="page-link" href="#!">
                {index + 1}
              </a>
            </li>
          ))}
        </ul>
      </nav>

      <h3>Registration of Alumini</h3>

      <Form onSubmit={handleSubmit} className="shadow p-4 rounded bg-light">
        <Form.Group controlId="formFullName" className="mb-3">
          <Form.Label>Your Full Name</Form.Label>
          <Form.Control 
            type="text" 
            placeholder="Enter your full name" 
            value={fullName} 
            onChange={(e) => setFullName(e.target.value)} 
            required 
          />
        </Form.Group>

        <Form.Group controlId="formMobileNumber" className="mb-3">
          <Form.Label>Mobile Number</Form.Label>
          <Form.Control 
            type="text" 
            placeholder="Enter your mobile number" 
            value={mobileNumber} 
            onChange={(e) => setMobileNumber(e.target.value)} 
            required 
          />
        </Form.Group>

        <Form.Group controlId="formEmailAddress" className="mb-3">
          <Form.Label>Email Address</Form.Label>
          <Form.Control 
            type="email" 
            placeholder="Enter your email address" 
            value={emailAddress} 
            onChange={(e) => setEmailAddress(e.target.value)} 
            required 
          />
        </Form.Group>

        <Form.Group controlId="formStayInHostelFrom" className="mb-3">
          <Form.Label>Stay in Hostel From</Form.Label>
          <Form.Select value={stayInHostelFrom} onChange={(e) => setStayInHostelFrom(e.target.value)} required>
            <option value="">Select Year</option>
            {years.map((year) => (
              <option key={year} value={year}>{year}</option>
            ))}
          </Form.Select>
        </Form.Group>

        <Form.Group controlId="formStayInHostelTo" className="mb-3">
          <Form.Label>To</Form.Label>
          <Form.Select value={stayInHostelTo} onChange={(e) => setStayInHostelTo(e.target.value)} required>
            <option value="">Select Year</option>
            {years.map((year) => (
              <option key={year} value={year}>{year}</option>
            ))}
          </Form.Select>
        </Form.Group>

        <Form.Group controlId="formQualification" className="mb-3">
          <Form.Label>Qualification</Form.Label>
          <Form.Control 
            type="text" 
            placeholder="Enter your qualification" 
            value={qualification} 
            onChange={(e) => setQualification(e.target.value)} 
            required 
          />
        </Form.Group>

        <Form.Group controlId="formCommunicationAddress" className="mb-3">
          <Form.Label>Communication Address</Form.Label>
          <Form.Control 
            type="text" 
            placeholder="Enter your communication address" 
            value={communicationAddress} 
            onChange={(e) => setCommunicationAddress(e.target.value)} 
            required 
          />
        </Form.Group>

        <Form.Group controlId="formPermanentAddress" className="mb-3">
          <Form.Label>Permanent Address</Form.Label>
          <Form.Control 
            type="text" 
            placeholder="Enter your permanent address" 
            value={permanentAddress} 
            onChange={(e) => setPermanentAddress(e.target.value)} 
            required 
          />
        </Form.Group>

        <Form.Group controlId="formWorkplace" className="mb-3">
          <Form.Label>Where are you working?</Form.Label>
          <Form.Control 
            type="text" 
            placeholder="Enter your workplace" 
            value={workplace} 
            onChange={(e) => setWorkplace(e.target.value)} 
            required 
          />
        </Form.Group>

        <div className="text-center">
          <Button variant="primary" type="submit" className="mt-3">
            Register
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default Alumni;
